import React, { useMemo } from 'react';
import { SageTokens, Button } from '@kajabi/sage-react';
import { CheckoutConfigData } from '../types';

const BUTTON_STYLES = ['solid', 'outline'];

const useCheckoutButtonStyles = (data: CheckoutConfigData = {} as CheckoutConfigData) => {
  const buttonBorderColor =
    data.checkoutButtonStyle === 'outline'
      ? data.checkoutButtonTextColor
      : data.checkoutButtonColor || SageTokens.COLOR_PALETTE.GREY_900;
  const buttonBackgroundColor =
    data.checkoutButtonStyle === 'outline'
      ? 'transparent'
      : data.checkoutButtonColor || SageTokens.COLOR_PALETTE.GREY_900;

  return useMemo(() => {
    const styles = {
      borderColor:
        data.checkoutButtonStyle !== 'outline'
          ? ''
          : buttonBorderColor || SageTokens.COLOR_PALETTE.GREY_900,
      textAlign: 'center',
    };

    if (data.checkoutButtonBorderRadius) {
      styles.borderRadius = `${data.checkoutButtonBorderRadius}px`;
    }

    if (data.checkoutButtonTextColor) {
      styles.color = data.checkoutButtonTextColor || SageTokens.COLOR_PALETTE.WHITE;
    }

    return {
      styles,
      ...data,
      checkoutButtonBackgroundColor: buttonBackgroundColor,
    };
  }, [data.checkoutPageColor, data.checkoutButtonBorderRadius, data.checkoutButtonTextColor]);
};

export default useCheckoutButtonStyles;
